// @flow
import React, { Component } from "react";

type Props = {};

class Header extends Component<Props> {
  render() {
    return (
      <header
        style={{
          textAlign: "center",
          marginBottom: 20,
        }}
      >
        <div>
          <img
            src={"chevron.png"}
            style={{ margin: "10px 0", width: 125, maxWidth: "75%" }}
            alt="Chevron"
          />
        </div>

        <div>
          <img
            src={"logo.png"}
            style={{ width: 450, maxWidth: "90%" }}
            alt="Champagne De Villepin"
          />
        </div>

        <div style={{ textAlign: "center", fontSize: 12, margin: "0 10px" }}>
          Elaboré par Bruno de Villepin à Boursault
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js